<div class="container-fluid px-0">
    <div class="row mx-0 pt-2">
        <div class="col-md-6 col-lg-6 col-xl-9 ps-md-0 ps-lg-0 px-xl-0">
            <div class="row mx-0 flex-column flex-xl-row gap-4 gap-xl-0">
             <div class="col-12 col-xl-4 px-0 pe-lg-3">
                <app-input 
                onlyNumbers
                [inputLabel]="'Cost'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.pricingModel?.cost"
                (inputValueEmit)="formModel.pricingModel.cost =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
             </div>
             <div class="col-12 col-xl-4 px-0 px-lg-3">
                <app-input 
                onlyNumbers
                [inputLabel]="'List Price'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.pricingModel?.listPrice"
                (inputValueEmit)="formModel.pricingModel.listPrice =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="col-12 col-xl-4 px-0 ps-lg-3">
                <app-input 
                [inputLabel]="'Resale'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.pricingModel?.reSale"
                (inputValueEmit)="formModel.pricingModel.reSale =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
         </div>
         <div class="row mx-0 py-3 flex-column flex-xl-row gap-4 gap-xl-0">
            <div class="col-12 col-xl-4 px-0 pe-lg-3">
                <app-input 
                onlyNumbers
                [inputLabel]="'Asset Account'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.pricingModel?.assetAccount"
                (inputValueEmit)="formModel.pricingModel.assetAccount =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="col-12 col-xl-4 px-0 px-lg-3">
               <app-input 
               onlyNumbers
               [inputLabel]="'Expense Account'" 
               [inputType]="'text'" 
               [inputValue]="formModel?.pricingModel?.expensesAccount1"
               (inputValueEmit)="formModel.pricingModel.expensesAccount1 =$event;"
               (parentFun)="onKeydown($event, '#description')"
               >
               </app-input>
           </div>
           <div class="col-12 col-xl-4 px-0 ps-lg-3">
            <app-input 
            onlyNumbers
            [inputLabel]="'Expense Account'" 
            [inputType]="'text'" 
            [inputValue]="formModel?.pricingModel?.expensesAccount2"
            (inputValueEmit)="formModel.pricingModel.expensesAccount2 =$event;"
            (parentFun)="onKeydown($event, '#description')"
            >
            </app-input>
           </div>
        </div> 
         <div class="row mx-0 flex-column flex-xl-row gap-4 gap-xl-0">
            <div class="col-12 col-xl-4 px-0 pe-lg-3">
                <app-input 
                [inputLabel]="'Discount Name'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.pricingModel?.discountName1"
                (inputValueEmit)="formModel.pricingModel.discountName1 =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="col-12 col-xl-4 px-0 px-lg-3">
               <app-input 
               [inputLabel]="'Qty Related'" 
               [inputType]="'text'" 
               [inputValue]="formModel?.pricingModel?.qtyRelated1"
               (inputValueEmit)="formModel.pricingModel.qtyRelated1 =$event;"
               (parentFun)="onKeydown($event, '#description')"
               >
               </app-input>
           </div>
           <div class="d-none d-xl-block col-4 px-0 ps-lg-3">
            <app-input 
               [inputLabel]="'Name'" 
               [inputType]="'text'" 
               [inputValue]="formModel?.pricingModel?.name1"
               (inputValueEmit)="formModel.pricingModel.name1 =$event;"
               (parentFun)="onKeydown($event, '#description')"
               >
               </app-input>
           </div>
        </div> 
       </div>
        <div class="col-md-6 col-lg-6 col-xl-9 pe-md-0 pe-lg-0 px-xl-0">
         <div class="row mx-0 flex-column flex-xl-row gap-4 py-4 py-md-0 gap-xl-0 py-xl-3">
            <div class="d-block d-xl-none col px-0">
                <app-input 
                   [inputLabel]="'Name'" 
                   [inputType]="'text'" 
                   [inputValue]="formModel?.pricingModel?.name1"
                   (inputValueEmit)="formModel.pricingModel.name1 =$event;"
                   (parentFun)="onKeydown($event, '#description')"
                   >
                   </app-input>
               </div>
    
            <div class="col-12 col-xl-4 px-0 pe-lg-3">
               <app-input 
               [inputLabel]="'Discount Name'" 
               [inputType]="'text'" 
               [inputValue]="formModel?.pricingModel?.discountName2"
               (inputValueEmit)="formModel.pricingModel.discountName2 =$event;"
               (parentFun)="onKeydown($event, '#description')"
               >
               </app-input>
           </div>
           <div class="col-12 col-xl-4 px-0 px-lg-3">
            <app-input 
            [inputLabel]="'Qty Related'" 
            [inputType]="'text'" 
            [inputValue]="formModel?.pricingModel?.qtyRelated2"
            (inputValueEmit)="formModel.pricingModel.qtyRelated2 =$event;"
            (parentFun)="onKeydown($event, '#description')"
            >
            </app-input>
           </div>
           <div class="col-12 col-xl-4 px-0 ps-lg-3">
            <app-input 
            [inputLabel]="'Name'" 
            [inputType]="'text'" 
            [inputValue]="formModel?.pricingModel?.name2"
            (inputValueEmit)="formModel.pricingModel.name2 =$event;"
            (parentFun)="onKeydown($event, '#description')"
            >
            </app-input>
           </div>
        </div>
        <div class="row mx-0 p-b-01rem flex-md-column flex-lg-column flex-xl-row gap-4 gap-xl-0 py-md-4 py-lg-4 py-xl-0">
            <div class="col-12 col-xl-4 px-0 pe-lg-3">
               <app-input 
               [inputLabel]="'Discount Name'" 
               [inputType]="'text'" 
               [inputValue]="formModel?.pricingModel?.discountName3"
               (inputValueEmit)="formModel.pricingModel.discountName3 =$event;"
               (parentFun)="onKeydown($event, '#description')"
               >
               </app-input>
           </div>
           <div class="col-12 col-xl-4 px-0 px-lg-3">
            <app-input 
            [inputLabel]="'Qty Related'" 
            [inputType]="'text'" 
            [inputValue]="formModel?.pricingModel?.qtyRelated3"
            (inputValueEmit)="formModel.pricingModel.qtyRelated3 =$event;"
            (parentFun)="onKeydown($event, '#description')"
            >
            </app-input>
           </div>
           <div class="col-12 col-xl-4 px-0 ps-lg-3">
            <app-input 
            [inputLabel]="'Name'" 
            [inputType]="'text'" 
            [inputValue]="formModel?.pricingModel?.name3"
            (inputValueEmit)="formModel.pricingModel.name3 =$event;"
            (parentFun)="onKeydown($event, '#description')"
            >
            </app-input>
           </div>
        </div>

        </div>
        <div class="col-3 d-xl-block d-md-none d-lg-none">
        </div>
    </div>
</div>